import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/devolucionProducto';
import Devolucion from './DevolucionProducto';


const ms2p = (state) => {
  return {
    ...state.devolucion_producto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Devolucion);
